import axios from 'axios'
import {
	Loading,
	Message
} from 'element-ui'
import Qs from 'qs'

import Vue from 'vue';

import md5 from './md5.js'

import base64 from './base64.js'

// 导入i18n工具函数
import { t } from './i18n-helper.js'

let loading;

function startLoading() { //使用Element loading-start 方法
	loading = Loading.service({
		lock: true,
		background: 'rgba(0, 0, 0, 0)',
		text: t('loadingText')
	})
}

function endLoading() { //使用Element loading-close 方法
	loading.close()
}

axios.create({
	baseURL: process.env.BASE_API, // api 的 base_url
	timeout: 500000, // 请求超时时间
	withCredentials: true
});
// sign加密
function getSign(data) {
	var appkey = '485cdce9bb';
	var secretKey = 'a65586cc5a2b4b8da2ce92ff46251a32';
	var keys = Object.keys(data);
	var values = Object.values(data);
	var timestamp = new Date().getTime().toString();
	data.timestamp = timestamp;
	data.appKey = appkey;
	data.secretKey = secretKey;
	var keyArr = Object.keys(data).sort();
	var arra = '';
	keyArr.forEach((key, index) => {
		arra += key + '=' + (data[key] === null ? '' : data[key]) + (index === keyArr.length - 1 ? '' : '&');
	});
	arra = arra.startsWith('&') ? arra.substring(1, arra.length) : arra;
	var sign = md5.hex_md5(base64.Base64.encode(arra, false));
	data['timestamp'] = timestamp;
	data['sign'] = sign;
	delete data.appKey
	delete data.secretKey
	return data;
}
//http request 拦截器
axios.interceptors.request.use(
	config => {
		let contentType = '';
		if (config.method.toUpperCase() === 'POST' || config.method.toUpperCase() === 'PUT') {
			if (config.data.postFileMethod === 'file-upload') {
				contentType = 'multipart/form-data;charset=UTF-8';
				config.body = config.data;
			} else {
				contentType = 'application/x-www-form-urlencoded;charset=UTF-8';
				config.data = Qs.stringify(config.data)
			}
		} else {
			contentType = 'application/json;charset=UTF-8'
		}
		config.headers['Content-Type'] = contentType;

		// let token = sessionStorage.getItem('token')
		// if (token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
		//   config.headers = {
		//     'X-token': token
		//   }
		// }
		startLoading();
		return config
	},
	err => {
		return Promise.reject(err)
	}
);


axios.interceptors.response.use(
	response => {
		setTimeout(() => {
			endLoading();
		}, 200);
		// console.log(response, '===>');
		if (response.data.code === 1001) {
			new Vue().$showNotFoundLoginComponent();
		} else if (response.data.code === 0) {
			new Vue().$closeLogin
		} else if (response.data.code !== 0) { //请求返回
			Message({
				message: response.data.msg,
				type: 'error',
				duration: 5 * 1000
			});
			// return;
		} else if (response.data.code === 5000) {
			Message({
				message: '登录已过期，请重新登录',
				type: 'error',
				duration: 5 * 1000
			});
			sessionStorage.clear();
			// return;
		}

		//   if (response.data.code === -1) {
		//     localStorage.removeItem('token')
		//     router.push({
		//       path:"/login",
		//       querry:{redirect: router.currentRoute.fullPath}//从哪个页面跳转
		//     })
		//   }
		return response
	},
	err => {
		endLoading();
		if (err.code === 'ECONNABORTED' && err.message.indexOf('timeout') !== -1) {
			Message({
				message: '网络异常，连接超时...',
				type: 'error',
				duration: 5 * 1000
			});
		}
		Message({
			message: '网络异常，连接超时...',
			type: 'error',
			duration: 5 * 1000
		});
		return Promise.reject(err)
	}
);

/**
 * get request
 * @param url
 * @param params
 * @param headers
 * @returns {Promise<any>}
 */
export function get(url, params = {}, headers = {}) {
	params.language = localStorage.getItem('lang') || 'zh_CN'
	params = getSign(params) || {}
	// console.log(params)
	return new Promise((resolve, reject) => {
		axios.get(url, {
				params: params,
				headers: headers
			})
			.then(response => {
				resolve(response.data);
			})
			.catch(err => {
				reject(err)
			})
	})
}

/**
 * post request
 * @param url
 * @param data
 * @returns {Promise<any>}
 */
export function post(url, data = {}) {
	data.language = !localStorage.getItem('lang') ? 'zh_CN' : localStorage.getItem('lang')
	data = getSign(data) || {}
	return new Promise((resolve, reject) => {
		axios.post(url, data)
			.then(response => {
				resolve(response.data);
			}, err => {
				reject(err)
			})
	})
}

export function put(url, data = {}) {
	data = getSign(data) || {}
	return new Promise((resolve, reject) => {
		axios.put(url, data)
			.then(response => {
				resolve(response.data);
			}, err => {
				reject(err)
			})
	})
}


export function deleteFn(url, params = {}, headers = {}) {
	params = getSign(params) || {}
	return new Promise((resolve, reject) => {
		axios.delete(url, {
				params: params,
				headers: headers
			})
			.then(response => {
				resolve(response.data);
			})
			.catch(err => {
				reject(err)
			})
	})
}
/**
 * 文件上传
 * @param options
 * @returns {Promise<any>}
 */
export function fileUpload(options) {
	console.log(options)
	return new Promise((resolve, reject) => {
		options.data.postFileMethod = 'file-upload';
		axios.post(options.url, options.data).then(response => {
			resolve(response.data);
		}, err => {
			reject(err)
		})
	});
}



// WEBPACK FOOTER //
// ./src/assets/js/request1.js